import { i18n } from "translations";
import { getLanContent, getMapObjectFromArray } from "utils";

import { StandardWorkingDayMethod, StandardWorkingDayObject } from "./types";

const text = {
  fixed: {
    label: {
      name: "Fixed",
      nativeName: "Công chuẩn cố định",
    },
    subLabel: {
      name: "Standard working days will be fixed according to each department / job title / work level or type of employee.",
      nativeName:
        "Công chuẩn cố định theo từng bộ phận / chức vụ / cấp bậc hoặc loại nhân viên.",
    },
  },
  calendar: {
    label: {
      name: "Base on actual calendar",
      nativeName: "Công chuẩn theo ngày làm việc thực tế",
    },
    subLabel: {
      name: "Standard working days will be calculated automatically = Number of days in the month - Number of weekend days.",
      nativeName: "Công chuẩn theo ngày đi làm và ngày nghỉ cuối tuần",
    },
  },
  employeeWorkingShift: {
    label: {
      nativeName: "Công chuẩn theo ca làm việc",
      name: "Base on employee's working shift",
    },
    subLabel: {
      name: "Standard working days will be calculated based on the approved working shifts of employees.",
      nativeName: "Công chuẩn theo ca làm việc đã được duyệt của nhân viên",
    },
  },
};

export const StandardWorkingDayMethodOptions = [
  {
    label: getLanContent(text.fixed.label, "name"),
    value: StandardWorkingDayMethod.Fixed,
    subLabel: getLanContent(text.fixed.subLabel, "name"),
  },
  {
    label: getLanContent(text.calendar.label, "name"),
    value: StandardWorkingDayMethod.Calendar,
    subLabel: getLanContent(text.calendar.subLabel, "name"),
  },
  {
    label: getLanContent(text.employeeWorkingShift.label, "name"),
    value: StandardWorkingDayMethod.EmployeeWorkingShift,
    subLabel: getLanContent(text.employeeWorkingShift.subLabel, "name"),
  },
];

export const StandardWorkingDayMethodMapping = getMapObjectFromArray(
  StandardWorkingDayMethodOptions
);

export const StandardWorkingDayObjectOptions = [
  {
    label: i18n.t("department"),
    value: StandardWorkingDayObject.Department,
  },
  {
    label: i18n.t("jobTitle"),
    value: StandardWorkingDayObject.JobTitle,
  },
  {
    label: i18n.t("workLevel"),
    value: StandardWorkingDayObject.WorkLevel,
  },
  {
    label: i18n.t("employeeType"),
    value: StandardWorkingDayObject.EmployeeType,
  },
];

export const StandardWorkingDayObjectMapping = getMapObjectFromArray(
  StandardWorkingDayObjectOptions
);
